
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import FillForm1SoughtInfo from "@/components/process/Form1/components/fillForm1/FillForm1SoughtInfo.vue";
import { form1StatesInfoType, form1DataInfoType, lookupsInfoType } from '@/types/Information/Form1';

@Component({
    components:{        
        FillForm1SoughtInfo        
    }
})
export default class FillForm1CommonInfo extends Vue {

    @commonState.State
    public lookups!: lookupsInfoType;
    
    @form1State.State
    public form1Info: form1DataInfoType;

    @form1State.State
    public form1InfoStates: form1StatesInfoType;

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void

    responseOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    appealedInSupremeCourtOptions = [
        { text: 'Yes', value: true },
        { text: 'Not Applicable', value: false }
    ]
    
    appealFromOptionsListNames = [];
    involvesOtherListNames = [];

    dataReady = false;
    commonInfo = {} as form1DataInfoType;

    mounted() { 
        this.dataReady = false;
        this.commonInfo = this.form1Info;
        this.extractFields();
        this.dataReady = true;
    }

    public extractFields(){
        this.involvesOtherListNames = [];
        this.appealFromOptionsListNames = [];

        for (const option of this.lookups.appealFromOptionsList){            
            this.appealFromOptionsListNames.push(option.name)
        }

        if (this.commonInfo.appealTribunal){           
            this.commonInfo.appealFrom = 'Order of a Tribunal';
        }

        for (const option of this.lookups.involvesOtherList){            
            this.involvesOtherListNames.push(option.name)
        }
    }

    public helpText(content: string){
        return {title: "<div style='margin: 0;'>" +content+ "</div>"};
    }

    public displayResults(){
        this.$emit('displayResults');
    }

    public update(){        
        this.UpdateForm1Info(this.commonInfo);
        this.recheckStates()
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');           
        return (date <= day);           
    }

    public recheckStates(){
        this.$emit('recheckStates')
    }

}
